<template>
  <div>
    <div class="chartheight" ref="chart"></div>
  </div>
</template>

<script>
export default {
  props: {
    position: null,
    showPosition: null,
  },
  data() {
    return {
      myCharts: null,
      chartData: [
        {
          value: this.position.financeCount,
          name: "金融从业者："+this.showPosition.financeCount+"人 ",
          itemStyle: { color: "#7e86ec" },
        },
        {
          value: this.position.medicalStaffCount,
          name: "医务人员："+this.showPosition.medicalStaffCount+"人 ",
          itemStyle: { color: "#7e86ec" },
        },
        {
          value: this.position.civilServantCount,
          name: "公务员："+this.showPosition.civilServantCount+"人 ",
          itemStyle: { color: "#7e86ec" },
        },
        {
          value: this.position.whiteCollarCount,
          name: "公司职员："+this.showPosition.whiteCollarCount+"人 ",
          itemStyle: { color: "#7e86ec" },
        },
        {
          value: this.position.workerCount,
          name: "工人："+this.showPosition.workerCount+"人 ",
          itemStyle: { color: "#7e86ec" },
        },
        {
          value: this.position.teacherCount,
          name: "教职工："+this.showPosition.teacherCount+"人 ",
          itemStyle: { color: "#7e86ec" },
        },
        {
          value: this.position.farmerCount,
          name: "农民："+this.showPosition.farmerCount+"人 ",
          itemStyle: { color: "#7e86ec" },
        },
        {
          value: this.position.studentCount,
          name: "学生："+this.showPosition.studentCount+"人 ",
          itemStyle: { color: "#7e86ec" },
        },
        {
          value: this.position.selfEmployedOrWaitressCount,
          name: "个体或服务业："+this.showPosition.selfEmployedOrWaitressCount+"人 ",
          itemStyle: { color: "#7e86ec" },
        },
        {
          value: this.position.cityWorkerCount,
          name: "城市其他职业："+this.showPosition.cityWorkerCount+"人 ",
          itemStyle: { color: "#7e86ec" },
        },
        {
          value: this.position.countrysideWorkerCount,
          name: "农村其他职业："+this.showPosition.countrysideWorkerCount+"人 ",
          itemStyle: { color: "#7e86ec" },
        },
        {
          value: this.position.unknownProfessionCount,
          name: "未识别："+this.showPosition.unknownProfessionCount+"人 ",
          itemStyle: { color: "#7e86ec" },
        },
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
      window.addEventListener("resize", () => {
        this.myCharts.resize();
      });
    });
  },
  methods: {
    initChart() {
      this.myCharts = this.$echarts.init(this.$refs.chart);
      this.setOptions(this.chartData);
    },
    setOptions(data) {
      let options = {
        tooltip: {
          trigger: "item",
          formatter: "职业 <br/>{b}({c}%)",
        },
        legend: {},
        grid: {
          top: "1%",
          left: "0",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        label: {
          formatter: function (params) {
            if (params.value) {
              return params.value + "%";
            } else {
              return "";
            }
          },
          color: "#999999",
          distance: 5,
          show: true, //开启显示
          position: "right", //在上方显示
          textStyle: {
            //数值样式
            color: "#999999",
            fontSize: 12,
            fontWeight: 700,
          },
        },
        xAxis: {
          type: "value",
          boundaryGap: [0, 0.01],
          axisLine: {
            //y轴
            show: false,
          },
          axisTick: {
            //y轴刻度线
            show: false,
          },
          splitLine: {
            //网格线
            show: true,
            color: "#999",
          },
          axisLabel: {
            interval: 0,
            formatter: "{value}%",
          },
        },
        yAxis: {
          type: "category",
          data: [
            "金融从业者",
            "医务人员",
            "公务员",
            "公司职员",
            "工人",
            "教职工",
            "农民",
            "学生",
            "个体或服务业",
            "城市其他职业",
            "农村其他职业",
            "未识别",
          ],
          axisTick: {
            //y轴刻度线
            color: "#666666",
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#666666",
            },
          },
        },
        series: [
          {
            type: "bar",
            data: data,
          },
        ],
      };
      this.myCharts.setOption(options);
    },
  },
};
</script>

<style scoped lang="scss">
.chartheight {
  height: 300px;
  margin-top: 10px;
  @media screen and (max-width: 1658px) {
    margin-top: 30px;
    height: 250px;
  }
  @media screen and (max-width: 1340px) {
    margin-top: 20px;
    height: 250px;
  }
}
</style>
